export const SITE_NAME_FIELD_NAME: string = 'siteName'
export const SITE_INDUSTRY_FIELD_NAME: string = 'siteIndustry'
export const ENTERPRISE_ID_FIELD_NAME: string = 'enterpriseID'
export const USER_NAME_FIELD_NAME: string = 'userName'
export const PASSWORD_FIELD_NAME: string = 'password'

export const USERS_ARRAY_FIELD_NAME: string = 'users'

export const USER_TYPE_FIELD_NAME: string = 'userType'
export const USER_EMAIL_FIELD_NAME: string = 'email'
export const USER_ARRAY_NAME_FIELD_NAME: string = 'name'
export const USER_ARRAY_WELCOME_EMAIL_FIELD_NAME: string = 'welcomeEmail'

export const userArrayFieldName = (fieldName: string, index: number): string =>
    `${USERS_ARRAY_FIELD_NAME}[${index}].${fieldName}`

export const CUSTOMER_REFERENCE_FIELD_NAME: string = 'customerReference'
